<template>
  <div class="p-12 rounded-lg shadow-lg bg-white">
    <ValidationObserver ref="observer">
      <template #default="{ handleSubmit }">
        <form class="text-sm" @submit.prevent="handleSubmit(doSubmit)">
          <PaymentDetails
            :issue-date.sync="data.issueDate"
            :account-uuid.sync="data.accountUuid"
            :account-relation-uuid.sync="data.accountRelationUuid"
            :notes.sync="data.notes"
            :issuer-options="issuerOptions"
            :account-relation-options="accountRelationOptions"
            :account-payment-account-options="accountPaymentAccountOptions"
            :disabled="disabled"
          />

          <PaymentLines
            :payment-lines.sync="data.paymentLines"
            :disabled="disabled"
            class="mt-12"
          />

          <div class="mt-16 border-t pt-12 text-right">
            <BaseButton primary class="px-6" :disabled="disabled"> Submit </BaseButton>
          </div>
        </form>
      </template>
    </ValidationObserver>
  </div>
</template>

<script>
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';
import PaymentDetails from './paymentForm/PaymentDetails.vue';
import PaymentLines from './paymentForm/PaymentLines.vue';

export default {
  mixins: [veeValidateErrorsMixin],

  components: {
    PaymentDetails,
    PaymentLines,
  },

  props: {
    defaultData: {
      type: Object,
      default: () => ({}),
    },
    issuerOptions: {
      type: Array,
      default: () => [],
    },
    accountRelationOptionsByIssuer: {
      type: Array,
      default: () => [],
    },
    paymentAccountOptionsByIssuer: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },

  data() {
    return {
      data: {
        issuerUuid: null,
        accountRelationUuid: null,
        notes: null,
        paymentLines: [
          {
            description: 'Πληρωμή',
            amount: 0,
          },
        ],
        ...this.defaultData,
      },
    };
  },

  computed: {
    accountRelationOptions() {
      if (!this.data.accountUuid) return [];

      return this.accountRelationOptionsByIssuer.filter(
        (accountRelation) => accountRelation.account_uuid === this.data.accountUuid
      );
    },
    accountPaymentAccountOptions() {
      if (!this.data.accountUuid) return [];

      return this.paymentAccountOptionsByIssuer.filter(
        ({ account_uuid: accountUuid }) => accountUuid === this.data.accountUuid
      );
    },
  },

  watch: {
    'data.accountUuid': {
      handler(accountUuid, oldAccountUuid) {
        if (!accountUuid || accountUuid !== oldAccountUuid) {
          this.data.accountRelationUuid = null;
          this.data.notes = null;
        }
      },
    },
  },

  methods: {
    doSubmit() {
      this.$emit('payment-form:submit', {
        ...this.data,
      });
    },
  },
};
</script>
